import styled from '@emotion/styled';
import Dialog from '@/components/Dialog';
import mediaQuery from '@/lib/styling/mediaQuery';

const PickerDialogTitle = styled(Dialog.Title)({
  display: 'flex',
  alignItems: 'center',
  '> .MuiSvgIcon-root': {
    marginRight: 12,
  },
  '.MuiIconButton-root': {
    marginTop: -1,
    marginBottom: -1,
    marginLeft: 8,
  },
  [mediaQuery(640)]: {
    fontSize: 18,
  },
});

export default PickerDialogTitle;
